import { Navigate, Route, HashRouter as Router, Routes, useLocation } from 'react-router-dom';
import './App.css';
import { CartProvider } from './CartContext';
import CartPage from './CartPage';
import CheckoutPage from './components/CheckoutPage';
import Footer from './components/Footer';
import Header from './components/Header';
import LoginPage from "./components/LoginPage";
import ShopDetailsAreaCat from './components/shopdetails/ShopDetailsAreaDog';
import './css/bootstrap.min.css';
import './css/responsive.css';
import './css/style.css';
import AdminLayout from "./layouts/Admin.js";
import BlogDetailsPage from './pages/BlogDetailsPage';
import BlogPage from './pages/BlogPage';
import BonPlans from './pages/BonPlans';
import CatList from './pages/CatList';
import ContactPage from './pages/ContactPage';
import DogList from './pages/DogList';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ShopDetailsPage from './pages/ShopDetailsPage';

import "@fortawesome/fontawesome-free/css/all.min.css";
import { useEffect, useState } from 'react';
import "./assets/plugins/nucleo/css/nucleo.css";
import "./assets/scss/argon-dashboard-react.scss";
import CategoryGridweb from './components/AnimaliaCategorySection.js';
import ProductsPage from './components/ourshop/ProductsPage.js';
import SubcategoryPage from './components/ourshop/SubcategoryPage.js';
import MainSearchPage from './components/search/MainSearchPage.js';
import { supabase } from './lib/supabaseClient.ts';
import BirdList from './pages/BirdList.js';
import RongeurList from './pages/RongeurList.js';

// Check authentication status
const isAuthenticated = () => {
  return localStorage.getItem("isAuthenticated") === "true";
};

// Protect routes that require login
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Prevent logged-in users from visiting login page
const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/admin/products" replace />;
  }
  return children;
};

function LayoutWithConditionalHeaderFooter({ children }) {
  const location = useLocation();

  // Pages where we hide header/footer
  const hideHeaderFooter =
    location.pathname.startsWith("/admin") || location.pathname === "/login";

  return (
    <>
      {!hideHeaderFooter && <Header />}
      {children}
      {!hideHeaderFooter && <Footer />}
    </>
  );
}

function App() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  // Fetch categories and products for 'cat'
  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "cat");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        setCategories(data);
        if (data.length > 0) {
          setSelectedCategory(data[0].name);
        }
      }
    };

    const fetchProducts = async () => {
      const { data, error } = await supabase
        .from("products")
        .select("id, name, image, price_range, description, category, subcategory");

      if (error) {
        console.error("Error fetching products:", error);
      } else {
        setProducts(data);
      }
    };

    fetchCategories();
    fetchProducts();
  }, []);
  return (
    <div className="app">
      <Router>
        <CartProvider>
          <LayoutWithConditionalHeaderFooter>
            <Routes>
              {/* Login page */}
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <LoginPage />
                  </PublicRoute>
                }
              />

              {/* Protected admin routes */}
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              />

              {/* Public routes */}
              <Route path="/" element={<Home />} />
              <Route path="/doglist" element={<DogList />} />
              <Route path="/catlist" element={<CatList />} />
              <Route path="/rongeurlist" element={<RongeurList />} />
              <Route path="/birdlist" element={<BirdList />} />
              <Route path="/contacts" element={<ContactPage />} />
              <Route path="/blogs" element={<BlogPage />} />
              <Route path="/bons" element={<BonPlans />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/blog-details" element={<BlogDetailsPage />} />
              <Route path="/search-results" element={<MainSearchPage />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/categories" element={<CategoryGridweb />} />
              <Route path="/shop-details/:id" element={<ShopDetailsPage />} />
              <Route path="/shop-detailsdog/:id" element={<ShopDetailsAreaCat />} />
              <Route path="/products" element={<ProductsPage products={products} categories={categories} />} />
              <Route path="/category/:id/:name" element={<SubcategoryPage />} />

              {/* Redirect unknown paths */}
              <Route
                path="*"
                element={
                  isAuthenticated() ? (
                    <Navigate to="/admin/index" replace />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
            </Routes>
          </LayoutWithConditionalHeaderFooter>
        </CartProvider>
      </Router>
    </div>
  );
}

export default App;
